import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PricePaidService {
  constructor() {}
  getPricePaid(): Observable<any[]> {
    return of([
      {
        id: 1,
        price_from: '0.00',
        price_to: '5.00'
      },
      {
        id: 2,
        price_from: '5.00',
        price_to: '10.00'
      },
      {
        id: 3,
        price_from: '10.00',
        price_to: '20.00'
      }
    ]);
  }
}
